import { Injectable, inject } from '@angular/core';
import {RouterStateSnapshot, TitleStrategy} from '@angular/router';
import {Title} from '@angular/platform-browser';
import {TranslateService} from '@ngx-translate/core';
import {take} from 'rxjs';

@Injectable()
export class PageTitleStrategy extends TitleStrategy {
  private translateService = inject(TranslateService);
  private readonly title = inject(Title);


  override updateTitle(snapshot: RouterStateSnapshot): void {
    const title = this.buildTitle(snapshot);
    if (title) {

      this.translateService.get(title)
        .pipe(take(1))
        .subscribe((translatedTitle) => {
        this.title.setTitle(`${translatedTitle} | RAIN MESH`);
      })
    } else {
      this.title.setTitle('RAIN MESH | Birco');
    }
  }
}
